
import { getErrorMessage } from '@/utils/invariant';

import { signIn, signOut, userManager } from '../services/oidc';
import { getUserRole } from '../utils/helpers';

import {
  setAuthStateType,
  setStatusFailed,
  setStatusLoading,
  setStatusSucceeded,
  signIn as signInAction,
  signOut as signOutAction,
  updateAuthState,
  updateState as updateStateAction,
  updateToken
} from './authSlice';

import type { ListenerMiddlewareInstance } from '@reduxjs/toolkit';

export default function applyAuthListeners(listenerMiddleware: ListenerMiddlewareInstance) {
  listenerMiddleware.startListening({
    type: signInAction.type,
    effect: async (_, listenerApi) => {
      listenerApi.dispatch(setStatusLoading());
      try {
        await signIn();
        listenerApi.dispatch(setStatusSucceeded());
      } catch (error) {
        listenerApi.dispatch(setStatusFailed(getErrorMessage(error, 'Sign In Failed')));
      }
    }
  });

  listenerMiddleware.startListening({
    type: signOutAction.type,
    effect: async (_, listenerApi) => {
      listenerApi.dispatch(setStatusLoading());
      try {
        await signOut();
        listenerApi.dispatch(setStatusSucceeded());
      } catch (error) {
        listenerApi.dispatch(setStatusFailed(getErrorMessage(error, 'Sign Out Failed')));
      }
    }
  });

  listenerMiddleware.startListening({
    type: updateStateAction.type,
    effect: async (_, listenerApi) => {
      listenerApi.dispatch(setStatusLoading());
      try {
        const user = await userManager.getUser();
        const role = getUserRole(user);
        listenerApi.dispatch(updateToken({ user, role }));
        listenerApi.dispatch(setStatusSucceeded());
      } catch (error) {
        console.error('updateToken-error', error);
        await userManager.signoutRedirect();
        listenerApi.dispatch(setStatusFailed(getErrorMessage(error, 'Update State Failed')));
      }
    }
  });

  listenerMiddleware.startListening({
    type: updateAuthState.type,
    effect: async (_, listenerApi) => {
      listenerApi.dispatch(setStatusLoading());
      try {
        const user = await userManager.getUser();
        const role = getUserRole(user);
        listenerApi.dispatch(setAuthStateType(role));
      } catch (error) {
        console.error('getAuthState-error', error);
        await userManager.signoutRedirect();
        listenerApi.dispatch(setStatusFailed(getErrorMessage(error, 'Get Auth State Failed')));
      }
    }
  });
}
